import { EstateResultItem_OneViewTradeInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  trade: EstateResultItem_OneViewTradeInput;
  assignButton?: React.ReactNode;
  title: string;
  subtitle: string;
};

export default function TradeAsset({
  id,
  showAssetBtn,
  trade,
  assignButton,
  title,
  subtitle,
}: Props) {
  return (
    <Asset
      key={id}
      id={id}
      showAssetBtn={showAssetBtn}
      assignButton={assignButton}
      itemData={[
        { field: 'Institution', value: trade.customerName },
        { field: 'Account Number', value: trade.accountNumber },
        { field: 'Date Opened', value: trade.dateOpened },
        { field: 'Date Reported', value: trade.dateReported },
        { field: 'Last Activity', value: trade.lastActiveDate },
        { field: 'Status', value: trade.status },
        { field: 'Creditor Name', value: trade.creditorName || 'N/A' },
        { field: 'Creditor Type', value: trade.creditorType || 'N/A' },
        { field: 'Date Closed', value: trade.dateClosed },
        { field: 'Balance', value: trade.balance },
        { field: 'Past Due Amount', value: trade.pastDueAmount },
        { field: 'Actions', value: trade.actions },
      ]}
      title={title}
      subtitle={subtitle}
    />
  );
}
